import MenuTip from './menu_tip'

export default MenuTip
